import {
  pecCoverageDecisionLabels,
  type PecDocumentListItem,
} from "cadendar-shared";
import {
  getCoverageExpiry,
  getPatientDate,
  getQuoteCoverage,
} from "../patientOverview";

export function PecDocumentStatus({
  document,
}: {
  document: PecDocumentListItem;
}) {
  const decision = document.coverageReviews.at(-1)?.decision;
  const expiry = getCoverageExpiry(document);
  const label =
    document.documentType === "coverage_request"
      ? "Demande disponible · envoi et réponse à vérifier"
      : document.documentType !== "coverage_response"
        ? "Document PEC à classer"
        : decision
          ? `${pecCoverageDecisionLabels[decision]} · décision confirmée`
          : "Réponse reçue · décision à confirmer";
  return (
    <div className="space-y-1 text-xs">
      <p
        className={
          decision === "refused" || expiry?.expired
            ? "font-medium text-amber-800"
            : "font-medium text-slate-700"
        }
      >
        {label}
      </p>
      {document.documentType === "coverage_response" &&
      decision !== "refused" ? (
        <p className={expiry?.expired ? "text-amber-800" : "text-slate-500"}>
          {expiry
            ? `${expiry.expired ? "Date de validité dépassée" : "Validité jusqu’au"} ${expiry.date} · date extraite à vérifier`
            : "Validité non renseignée"}
        </p>
      ) : null}
      {document.documentType === "coverage_response" &&
      document.ocrStatus === "completed" &&
      (document.ocrData?.totalPecCents != null ||
        document.ocrData?.patientResponsibilityCents != null) ? (
        <p className="text-slate-500">
          Montants extraits à vérifier :{" "}
          {[
            document.ocrData.totalPecCents != null
              ? `PEC ${(document.ocrData.totalPecCents / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}`
              : null,
            document.ocrData.patientResponsibilityCents != null
              ? `part patient ${(document.ocrData.patientResponsibilityCents / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}`
              : null,
          ]
            .filter(Boolean)
            .join(" · ")}
        </p>
      ) : null}
    </div>
  );
}

export default function PecCoverageStatus({
  documents,
  quoteId,
  onOpenDocument,
}: {
  documents: PecDocumentListItem[];
  quoteId: string;
  onOpenDocument: (documentId: string) => void;
}) {
  const linked = documents.filter((document) => document.quoteId === quoteId);
  if (!linked.length)
    return (
      <p className="text-xs text-slate-500">
        Aucune PEC liée · nécessité non renseignée
      </p>
    );
  const networks = [...new Set(linked.map((document) => document.network))];
  return (
    <div className="space-y-2">
      {networks.map((network) => {
        const coverage = getQuoteCoverage(
          linked.filter((document) => document.network === network),
          quoteId,
        );
        if (!coverage.latest) return null;
        const document = coverage.latest;
        return (
          <div key={network} className="border-l-2 border-slate-200 pl-2">
            <p className="mb-1 text-xs font-medium uppercase text-slate-500">
              PEC · {network}
            </p>
            <PecDocumentStatus document={document} />
            <p className="mt-1 text-xs text-slate-400">
              Dernière pièce capturée ·{" "}
              {getPatientDate(document.capturedAt).toFormat("dd/MM/yyyy")}
            </p>
            <button
              type="button"
              className="mt-1 text-xs font-medium text-blue-700 hover:underline"
              onClick={() => onOpenDocument(document.id)}
            >
              Voir le document
              {coverage.documents.length > 1
                ? ` (${coverage.documents.length} pièces)`
                : ""}
            </button>
          </div>
        );
      })}
    </div>
  );
}
